module.exports = __webpack_public_path__ + "static/media/gitInfo.a231480b.txt";